'use client';

import { useLocale } from 'next-intl';
import dynamic from 'next/dynamic';
import React from 'react';

import { Header } from '@ui/sections/header/Header';
import { useUserType } from '@website/hooks/useCurrentUser';
import { useHasMounted } from '@website/hooks/useHasMounted';

const HeaderAuthSection = dynamic(() => import('./HeaderAuthSection').then((mod) => mod.HeaderAuthSection), {
  ssr: false,
  loading: () => <div></div>
});

interface AppHeaderProps {
  rightActions?: React.ReactNode;
  /** The page has its own share button (a Hub page): the professional's "share my profile" steps aside. */
  hideProfileShare?: boolean;
}

/**
 * Application-specific header component for the website.
 * Fully static - auth section is a client component that handles user state.
 */
export default function AppHeader({ rightActions, hideProfileShare = false }: AppHeaderProps) {
  const locale = useLocale();
  const userType = useUserType();
  const hasMounted = useHasMounted();

  const logoHref = hasMounted && userType === 'professional' ? `/${locale}/dashboard` : `/${locale}`;

  return (
    <Header
      logoHref={logoHref}
      rightActions={
        <>
          {rightActions}
          <HeaderAuthSection hideProfileShare={hideProfileShare} />
        </>
      }
    />
  );
}
